import {memoryStorage} from "./memory-storage.js";

const getFormNotificationsLocales = () => {
    const lang = document.documentElement.lang;
    const locales = {
        "ru-RU": {
            "error": "Не удалось отправить заявку",
            "success": `Заявка успешно отправлена. <br> <span class="sub" style="font-size: var(--font-size-xm)">Мы свяжемся с Вами в ближайшее время.</span>`,
            "phone_error": "Некорректный номер телефона"
        },
        "uz-UZ": {
            "error": "Ariza yuborilmadi",
            "success": `Ariza muvaffaqiyatli yuborildi. <br> <span class="sub" style="font-size: var(--font-size-xm)">Biz siz bilan yaqin vaqt ichida bog‘lanamiz.</span>`,
            "phone_error": "Noto‘g‘ri telefon raqami"
        },
    };

    return locales[lang];
};

const getRecaptchaToken = () => {
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha?.enterprise) {
            reject(new Error("reCAPTCHA is not loaded"));
            return;
        }

        window.grecaptcha.enterprise.ready(async () => {
            try {
                const token = await window.grecaptcha.enterprise.execute(
                    "6LcM2YMtAAAAALTKRaHkBK2f7WpjNZfIgdN-ZvQ7",
                    {
                        action: "APPLICATION"
                    }
                );

                if (!token) {
                    reject(new Error("reCAPTCHA token is empty"));
                    return;
                }

                resolve(token);
            } catch (error) {
                reject(error);
            }
        });
    });
};

export function contactFormInit() {
    const locales = getFormNotificationsLocales();
    const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());

    const validatePhoneInput = (phone) => {
        const phoneDigits = phone.replace(/\D+/g, '');        

        if (phoneDigits.length !== 12) {
            throw new Error(locales.phone_error);
        }
    };

    const sendDataToGoogleSheets = (data) => {
        return fetch("https://script.google.com/macros/s/AKfycbxkVQelkyRkOcnYvsw92df4DXh4AygGW1EPEYUHtE_G3AGVSd49Py4fA02_GWTQDnY_/exec", {
            method: "POST",
            body: JSON.stringify(data),
            mode: "no-cors"
        });
    };

    const sendDataToBitrix = (data) => {
        return fetch("/bx24-webhook/sendlead.php", {
            method: "POST",
            body: JSON.stringify(data)
        });
    };

    const renderSuccessDialog = (form) => {
        form.classList.add("form-success");
        form.innerHTML = `
            <div class="success-icon">
                <svg width="800px" height="800px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="okIconTitle" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="currentColor"> <title id="okIconTitle">Ok</title> <polyline points="4 13 9 18 20 7"/> </svg>
            </div>
            <h5 class="success">
                ${locales.success}
            </h5>
        `;
    };

    const onSubmit = async (e) => {
        const form = e.target.closest(".callback-form.site-form");

        if (!form) return;

        e.preventDefault();
        e.stopPropagation();

        const button = form.querySelector(".site-btn");
        const formElements = form.elements;

        const memoryStorageContactFormData = memoryStorage.get("silen-calc-data") || {}; // silen page
        const memoryStorageAdditionalModulesData = memoryStorage.get("modules-data") || {}; // prices page
        const memoryStorageModalData = memoryStorage.get("modal-data") || {}; // modal data

        const googleSheetsUtms = {
            utm_source: queryParams?.utm_source ? queryParams.utm_source : "-",
            utm_medium: queryParams?.utm_medium ? queryParams.utm_medium : "-",
            utm_campaign: queryParams?.utm_campaign ? queryParams.utm_campaign : "-",
            utm_term: queryParams?.utm_term ? queryParams.utm_term : "-",
            utm_content: queryParams?.utm_content ? queryParams.utm_content : "-"
        };

        const additionalData = {
            ...googleSheetsUtms,
            action: "Оставить заявку",
            ...memoryStorageModalData,
            silen_calc: memoryStorageContactFormData,
            additional_modules: memoryStorageAdditionalModulesData,
        };

        const data = {
            name: formElements.fullName.value,
            phone: formElements.phone.value,
            source: formElements.source?.value?.toUpperCase(),
            ...additionalData
        };

        console.log(data, "form data");

        try {
            validatePhoneInput(data.phone);

            const token = await getRecaptchaToken();

            data.recaptcha_token = token;

            button.classList.add("site-btn--loading");

            const requests = [
                //sendDataToGoogleSheets({ ...data, recaptcha_token: undefined }),
                sendDataToBitrix(data)
            ];

            const responses = await Promise.allSettled(requests);

            const resolvedRequest = responses.find(
                (res) => res.status === "fulfilled" && res.value?.ok
            );

            if (resolvedRequest) {
                renderSuccessDialog(form.parentElement);

                if (typeof gtag === "function") {
                    gtag("event", "generate_lead", {
                        currency: "USD",
                        value: 1.00
                    });
                }
            } else {
                throw new Error(locales.error);
            }
        } catch (e) {
            const $err = form.querySelector(".error-message");

            if ($err) {
                $err.remove();
            }

            form.insertAdjacentHTML("afterbegin", `<div class="error-message">${e.message}</div>`);
        } finally {
            button.classList.remove("site-btn--loading");
        }
    };

    document.addEventListener("submit", onSubmit);
}